import { X } from '@phosphor-icons/react';
import clsx from 'clsx';
import { TextInput, Typography } from '@la/ds-ui-components';
import styles from './ESignature.module.scss';

export type ESignatureProps = {
  errorMessage?: string;
  eSignature?: string;
  hasError?: boolean;
  onChange: (eSignature: string) => void;
  showError?: boolean;
};

export function ESignature({
  errorMessage,
  eSignature,
  hasError,
  onChange,
  showError = true,
}: ESignatureProps) {
  return (
    <>
      <div className={styles.eSignatureContainer}>
        <TextInput
          errorMessage={hasError && errorMessage ? errorMessage : undefined}
          hasError={hasError}
          id="e-signature"
          label="Enter your full name"
          onChange={(e) => onChange(e.currentTarget.value)}
          placeholder="Enter your full name"
          size="large"
          value={eSignature}
        />
        <div
          className={clsx({
            [styles.eSignature]: true,
            [styles.hasError]: hasError && showError,
          })}
        >
          <X fill="var(--blue-grey-400)" size={20} weight="bold" />
          <div className={styles.signature}>{eSignature}</div>
        </div>
      </div>
      <Typography size="medium" variant="ui">
        <span className={styles.eSignatureDisclaimer}>
          By entering my name, I confirm I have read and agree to be bound by
          the agreements and waivers for this program and that my electronic
          signature is the legal equivalent of my handwritten signature.
        </span>
      </Typography>
    </>
  );
}
